module.exports = __webpack_public_path__ + "static/media/myImage.8554bab5.gif";